module.exports = __webpack_public_path__ + "static/sorrowful_5-8fd5426deb10fc5c3c747668d544e90f.jpg";